import React from 'react'
import UserContainer from 'components/ControlledUser'
import { useUsersNotInBoardProvider } from 'components/UsersNotInBoardProvider'
import { useBoardContext } from 'dataProviders/Board'
import { useSelector } from 'react-redux'

const BoardUser: React.FC<{ id: number; } & React.ComponentProps<typeof UserContainer>> = ({
  id,
  ...props
}) => {
  const boardContext = useBoardContext()

  useUsersNotInBoardProvider(boardContext.id, id)

  const isInBoard = useSelector(state => state['view-board'].usersNotInBoard[boardContext.id]?.usersById[id]?.isInBoard)

  const userProps: any = {
    id,
    ...props
  }
  if (isInBoard === false) {
    userProps.isActive = false
  }

  return <UserContainer {...userProps} />
}

export default BoardUser
